import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { assetGuardRoutes } from "./Components/AssetGuardRoutes";
import { authPublicRoutes } from "./Components/AuthRoutes";
import { coreRoutes } from "./Components/CoreRoutes";
import { dmsRoutes } from "./Components/DMSRoutes";
import { fleetGuardRoutes } from "./Components/FleetGuardRoutes";
import { fmsRoutes } from "./Components/FMSRoutes";
import { ntmsRoutes } from "./Components/NTMSRoutes";
import { othersPublicRoutes } from "./Components/OthersRoutes";
import { payflowRoutes } from "./Components/PayflowRoutes";
import { peopleSyncRoutes } from "./Components/PeopleSyncRoutes";
import { procurementRoutes } from "./Components/ProcurementRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    ...coreRoutes,
    ...ntmsRoutes,
    ...assetGuardRoutes,
    ...fleetGuardRoutes,
    ...fmsRoutes,
    ...peopleSyncRoutes,
    ...payflowRoutes,
    ...dmsRoutes,
    ...procurementRoutes,

    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/peoplesync/dashboards/employee" /> },
    { path: "*", component: <Navigate to="/pages-coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
    ...othersPublicRoutes,
];